import { render, staticRenderFns } from "./UserArticlesList2.vue?vue&type=template&id=85075eea&"
import script from "./UserArticlesList2.vue?vue&type=script&lang=js&"
export * from "./UserArticlesList2.vue?vue&type=script&lang=js&"
import style0 from "./UserArticlesList2.vue?vue&type=style&index=0&id=85075eea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports